import { Component, ViewChild } from "@angular/core";
import { Nav, Platform, AlertController, Events } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";

import { Storage } from "@ionic/storage";

import { LoginPage } from "../pages/login/login";

import { TabsPage } from "../pages/tabs/tabs";

import { TranslateService } from "@ngx-translate/core";

import { ApiProvider } from "../providers/api/api";


@Component({
	templateUrl: "app.html",
})
export class MyApp {
	@ViewChild(Nav) nav: Nav;

	rootPage: any;

	pages: Array<{ title: string; component: any; classe: string }>;

	constructor(
		public  platform    : Platform,
		public  statusBar   : StatusBar,
		public  splashScreen: SplashScreen,
		private storage     : Storage,
		public  alertCtrl   : AlertController,
		public  events      : Events,
		public  translate   : TranslateService,
		private _api        : ApiProvider,
	) {
		this.initializeApp();
	}

	initializeApp() {
		console.log("📲 App is running");


		this.platform.ready().then(() => {
			var checkWhatsapp = this.platform.getQueryParam("whatsapptoken");
			if (checkWhatsapp) {
				this.storage.set('whatsapp', 1);
			}

			this.storage.get("lng").then((lng) => {
				this.translate.setDefaultLang(lng);
				this.translate.use(lng);

				this.storage.get("id_cliente").then((val) => {
					// this.splashScreen.hide();

					if (val == null) {
						this.rootPage = LoginPage;
					} else {
						// this.rootPage = HomePage;
						this.rootPage = TabsPage;
					}

				});
			});
		});
	}


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts